<template>
	<div class="add-product-tag">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="
				productTag.id ? $t('addProductTag.edit') : $t('addProductTag.add')
			"
			:visible.sync="dialogProductTag"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="productTag"
					label-width="80px"
					:model="productTag">
					<el-form-item :label="$t('addProductTag.name')" prop="name">
						<el-input
							v-model="productTag.name"
							:placeholder="$t('addProductTag.pName')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('addProductTag.notes')">
						<el-input
							type="textarea"
							:rows="4"
							v-model="productTag.notes"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('productTag')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddProductTag",
	props: {
		productTag: Object,
		dialogProductTag: Boolean,
	},
	data() {
		return {
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addProductTag.pName"),
						trigger: "blur",
					},
				],
			},
			clear: false,
			loadingForm: false,
		};
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		closeDialog() {
			this.clearValidate("productTag");
			if (this.productTag.id) {
				this.$toolUtil.clearForm(this.productTag);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.productTag);
				}
			}
			this.cancel("");
		},
		openDialog() {},
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.ProductTag.insert;
					let method = this.$method.post;
					if (this.productTag.id) {
						url = this.$url.ProductTag.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.productTag)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.productTag.id ? "update" : "save");
							} else {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "warning",
								});
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style scoped></style>
